import { render, staticRenderFns } from "./voting.vue?vue&type=template&id=0c294bbb&scoped=true&"
import script from "./voting.vue?vue&type=script&lang=js&"
export * from "./voting.vue?vue&type=script&lang=js&"
import style0 from "./voting.vue?vue&type=style&index=0&id=0c294bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c294bbb",
  null
  
)

export default component.exports